/** 与 /peripheralcontrol 系列接口 peripheral_type 一致：0 未知、1 U盘、2 便携设备（筛选项仍仅用 1、2 见 PERIPHERAL_TYPE_VALUES） */
export const PERIPHERAL_TYPE_VALUES = [1, 2] as const

const PERIPHERAL_TYPE_KEYS: Record<number, 'usbPolicy.unknown' | 'equipmentView.usb' | 'equipmentView.portable'> = {
  0: 'usbPolicy.unknown',
  1: 'equipmentView.usb',
  2: 'equipmentView.portable',
}

export function getPeripheralTypeLabel (
  type: number | string | undefined | null,
  t: (key: string) => string
): string {
  const n = typeof type === 'string' ? parseInt(type, 10) : type
  if (n == null || Number.isNaN(n)) return ''
  const key = PERIPHERAL_TYPE_KEYS[n]
  return key ? t(key) : ''
}
